import React, { useCallback } from 'react';

import { Rooms } from '@search/filter-enums/enums';
import Checkbox from '@search/vtbeco-ui/src/components/controls/NewCheckbox';

import { RoomFilter } from '../../../../models/Filter';
import { IFilterAvailableProps } from '../../../new_filter/Filter2';
import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { CheckboxGroup2, ICheckboxGroupModificationProps } from '../../../common/CheckboxGroup2';

interface IDesktopRoomInHouseFilterViewProps extends ICheckboxGroupModificationProps, IFilterAvailableProps {
    filter: RoomFilter;
    handleChange: (filter: RoomFilter) => void;
    isMobile?: boolean;
}

enum ClientRooms {
    ROOM_1 = 2,
    ROOM_2 = 3,
    ROOM_3 = 4,
    ROOM_4_AND_MORE = 5,
}

const selectOptions = [ {
    value: ClientRooms.ROOM_1,
    label: '1'
}, {
    value: ClientRooms.ROOM_2,
    label: '2'
}, {
    value: ClientRooms.ROOM_3,
    label: '3'
}, {
    value: ClientRooms.ROOM_4_AND_MORE,
    label: '4+'
} ];

function getClientValue(rooms: Rooms[]): ClientRooms[] {
    return rooms.reduce((acc, room) => {
        if (
            room === Rooms.ROOM_1 ||
            room === Rooms.ROOM_2 ||
            room === Rooms.ROOM_3 ||
            room === Rooms.ROOM_4
        ) {
            acc.push(room as unknown as ClientRooms);
        } else if (room === Rooms.ROOM_5_AND_MORE) {
            if (! acc.includes(ClientRooms.ROOM_4_AND_MORE)) {
                acc.push(ClientRooms.ROOM_4_AND_MORE);
            }
        }
        return acc;
    }, [] as ClientRooms[]);
}

function getFilterValue(rooms: ClientRooms[]): Rooms[] {
    return rooms.reduce((acc, room) => {
        if (
            room === ClientRooms.ROOM_1 ||
            room === ClientRooms.ROOM_2 ||
            room === ClientRooms.ROOM_3
        ) {
            acc.push(room as unknown as Rooms);
        } else if (room === ClientRooms.ROOM_4_AND_MORE) {
            acc.push(Rooms.ROOM_4, Rooms.ROOM_5_AND_MORE);
        }

        return acc;
    }, [] as Rooms[]);
}

export const DesktopRoomInHouseFilterSelectView: React.FC<IDesktopRoomInHouseFilterViewProps> = ({
    filter,
    handleChange,
    withoutTitle,
    classNameGroup,
    isMobile
}) => {
    const onChange = useCallback(value => {
        const filterValue = getFilterValue(value);

        handleChange(new RoomFilter(filterValue));
    }, [ handleChange ]);

    return (
        <MobileFilter2 desktopTitleGap={! isMobile} filterTitle={withoutTitle ? undefined : 'Комнат в доме'}>
            <CheckboxGroup2
                mode='check'
                onChange={onChange}
                name='roomInHouse'
                value={getClientValue(filter.rooms)}
                withoutGrid
                classNameGroup={classNameGroup}
            >
                {selectOptions.map(({ value, label }) => (
                    <Checkbox
                        type='button'
                        view='primary'
                        tone='secondary'
                        size='xs'
                        key={value}
                        value={value}
                    >
                        {label}
                    </Checkbox>
                ))}
            </CheckboxGroup2>
        </MobileFilter2>
    );
};
